function decodeBase64UrlJSON(segment) {
  if (!segment) return null;
  const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
  try {
    const json = typeof atob === 'function'
      ? decodeURIComponent(Array.prototype.map.call(atob(padded), (ch) => `%${`00${ch.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''))
      : Buffer.from(padded, 'base64').toString('utf8');
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

function decodeERPAccessPayload(accessToken) {
  if (!accessToken || typeof accessToken !== 'string') return null;
  const token = accessToken.startsWith('Bearer ') ? accessToken.slice(7) : accessToken;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  return decodeBase64UrlJSON(parts[1]);
}

function parseCachedImpersonation(cacheValue) {
  if (!cacheValue) return null;
  try {
    const parsed = JSON.parse(cacheValue);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (e) {
    return null;
  }
}

function resolveImpersonationSession(accessToken, cacheValue) {
  const payload = decodeERPAccessPayload(accessToken);
  if (!payload || payload.is_impersonated !== true || Number(payload.impersonation_ticket_id || 0) <= 0) {
    return null;
  }

  const cached = parseCachedImpersonation(cacheValue);
  if (!cached || cached.enabled !== true) {
    return null;
  }
  if (Number(cached.ticket_id || 0) !== Number(payload.impersonation_ticket_id)) {
    return null;
  }
  return cached;
}

function getERPAccessToken(cookieAccessToken, impersonationAccessToken) {
  return impersonationAccessToken || cookieAccessToken || '';
}

function hasERPAuthTokens(cookieAccessToken, cookieRefreshToken, impersonationAccessToken, impersonationRefreshToken) {
  return !!(
    (impersonationAccessToken && impersonationRefreshToken)
    || (cookieAccessToken && cookieRefreshToken)
  );
}

module.exports = {
  decodeERPAccessPayload,
  getERPAccessToken,
  hasERPAuthTokens,
  resolveImpersonationSession,
};
